// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3RR4O","loaderOuter":"PageOverlayLoader_loaderOuter__CIEmY"};